import { sleep } from './index';

export async function fetchWithRetries(
    requestInfo: RequestInfo,
    requestInit?: RequestInit,
    options?: {
        retryCount?: number;
        timeoutMilliseconds?: number;
    },
): Promise<Response> {
    const retryCount = options?.retryCount ?? 3;
    const timeoutMilliseconds = options?.timeoutMilliseconds ?? 20_000;
    let lastError: Error | null = null;
    for (let currentAttempt = 0; currentAttempt < retryCount; currentAttempt += 1) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), timeoutMilliseconds);
        try {
            const response = await fetch(requestInfo, {
                ...requestInit,
                signal: controller.signal,
            });
            if (response.ok) {
                clearTimeout(timeout);
                return response;
            } else {
                lastError = new Error(`Attempt ${currentAttempt + 1}: ${response.status} ${response.statusText}`);
            }
        } catch (error) {
            lastError = error;
        } finally {
            clearTimeout(timeout);
        }
        if (currentAttempt < retryCount - 1) {
            await sleep(1_000 * currentAttempt);
        }
    }
    throw lastError ?? new Error('fetchWithRetries failed');
}
